import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/widgets/app-shell/app-shell";

export const Route = createFileRoute("/")({
  component: HomePage,
});

function HomePage(): React.JSX.Element {
  return <AppShell />;
}
